import { useState } from 'react';
import Hero from './components/Hero';
import ProductCategories from './components/ProductCategories';
import FeaturedWork from './components/FeaturedWork';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import Newsletter from './components/Newsletter';
import Footer from './components/Footer';
import Navbar from '../../components/feature/Navbar';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <ProductCategories />
      <FeaturedWork />
      <AboutSection />
      <ContactSection />
      <Newsletter />
      <Footer />
    </div>
  );
}
